module.exports = __webpack_public_path__ + "assets/images/jb6UbjVb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/document.svg
// module id = 426
// module chunks = 0